export const SKIP_VERIFICATION = 'classpass/phoneVerification/SKIP_VERIFICATION';

export const skipPhoneVerification = () => ({ type: SKIP_VERIFICATION });

const initialState = {
  skipVerification: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SKIP_VERIFICATION:
      return {
        ...state,
        skipVerification: true,
      };
    default:
      return state;
  }
}
